import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { EmailVerification, ToastContext } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'

import useVerifyEmail from './hooks/useVerifyEmail/useVerifyEmail'
import * as Styles from './styles'

const VerifyAccountStep = () => {
  const { context } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const { t } = useTranslation()
  const { onResendEmail, validateEmail } = useVerifyEmail({ sendValidationCodeOnInit: true, setToastInfo })

  return (
    <Styles.EmailVerificationContainer>
      <Styles.SubTitle>{t('Valida tu correo')}</Styles.SubTitle>
      <p>
        {t(
          'Introduce el código de verificación que encontrarás en el cuerpo del mensaje que te hemos enviado a tu dirección de correo'
        )}
        :
      </p>
      <p>
        <strong>{context?.orderInfo?.customer_profile?.email?.email}</strong>
      </p>
      <p>
        {t(
          'Este paso es necesario cada vez que añadas una nueva cuenta bancaria para proteger tus datos de forma segura'
        )}
        :
      </p>
      <EmailVerification
        size={6}
        onValidate={validateEmail}
        onResendEmail={onResendEmail}
        resendEnableOnInit={false}
        name="emailVerification"
        buttonFullWidth={true}
      />
    </Styles.EmailVerificationContainer>
  )
}

export default VerifyAccountStep
